<template>
  <aside class="panel funcbar">
    <div class="func-top">
      <div class="func-brand-block" id="funcBrandBlock">
        <span class="func-brand-logo">
          <svg viewBox="0 0 24 24" fill="none" style="width:18px;height:18px;display:block"><rect x="4" y="8" width="16" height="11" rx="3.2" stroke="currentColor" stroke-width="1.8"></rect><path d="M12 4.4V8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path><circle cx="12" cy="3.4" r="1.4" fill="currentColor"></circle><circle cx="9" cy="13" r="1.35" fill="currentColor"></circle><circle cx="15" cy="13" r="1.35" fill="currentColor"></circle><path d="M9.5 16.2h5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"></path><path d="M4 12.5H2.4M20 12.5h1.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path></svg>
        </span>
        <span class="func-brand-copy">
          <strong class="func-brand-name">ARP</strong>
          <small class="func-brand-sub">AgentOS</small>
        </span>
      </div>
      <button
        class="func-expand-btn"
        id="funcExpandBtn"
        type="button"
        aria-label="展开导航"
        title="展开导航"
        @click="toggleFuncBar"
      >
        <svg viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"></path></svg>
      </button>
      <button
        :class="['panel-toggle funcbar-collapse-btn', { 'is-collapsed': funcbarCollapsed }]"
        id="funcCollapseBtn"
        type="button"
        :aria-label="funcbarCollapsed ? '展开导航' : '收起导航'"
        :aria-expanded="!funcbarCollapsed"
        :title="funcbarCollapsed ? '展开导航' : '收起导航'"
        @click="toggleFuncBar"
      >
        <svg viewBox="0 0 24 24" fill="none"><path d="M15 6 9 12l6 6" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"></path></svg>
      </button>
    </div>
    <div class="func-menu">
      <!-- 工作 -->
      <div class="func-group-label" :class="{ 'is-collapsed': groupsCollapsed.work }" @click="toggleGroup('work')">
        <span>工作</span>
        <span class="group-toggle-icon"><svg viewBox="0 0 24 24" fill="none" width="12" height="12"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
      </div>
      <div
        class="func-item"
        :class="{ active: $route.name === 'messages' && !activeRecentId }"
        v-show="!groupsCollapsed.work"
        id="messagesNavItem"
        @click="navigate('messages')"
      >
        <span class="func-icon"><svg viewBox="0 0 24 24" fill="none"><path d="M7 10h10M7 14h6M6 20l-2 1V6a2 2 0 012-2h12a2 2 0 012 2v9a2 2 0 01-2 2H9l-3 3z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
        <span class="func-label"><strong>对话</strong><small>Conversations</small></span>
        <span class="func-item-badge" v-if="totalUnread > 0">{{ totalUnread > 99 ? '99+' : totalUnread }}</span>
      </div>
      <div
        class="func-item"
        :class="{ active: $route.name === 'dev' && !activeRecentId }"
        v-show="!groupsCollapsed.work"
        @click="navigate('dev')"
      >
        <span class="func-icon"><svg viewBox="0 0 24 24" fill="none"><polyline points="16 18 22 12 16 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><polyline points="8 6 2 12 8 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <span class="func-label"><strong>开发</strong><small>Developer</small></span>
      </div>

      <!-- 协作 -->
      <div class="func-group-label" :class="{ 'is-collapsed': groupsCollapsed.collab }" @click="toggleGroup('collab')">
        <span>协作</span>
        <span class="group-toggle-icon"><svg viewBox="0 0 24 24" fill="none" width="12" height="12"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
      </div>
      <div
        class="func-item"
        :class="{ active: $route.name === 'collab' && !activeRecentId }"
        v-show="!groupsCollapsed.collab"
        @click="navigate('collab')"
      >
        <span class="func-icon"><svg viewBox="0 0 24 24" fill="none"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14 2v6h6M10 13h4M10 17h4M8 13h.01M8 17h.01" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
        <span class="func-label"><strong>云文档</strong><small>Cloud Docs</small></span>
      </div>
      <div
        class="func-item"
        :class="{ active: $route.name === 'knowledge' && !activeRecentId }"
        v-show="!groupsCollapsed.collab"
        @click="navigate('knowledge')"
      >
        <span class="func-icon"><svg viewBox="0 0 24 24" fill="none"><path d="M4 19.5A2.5 2.5 0 016.5 17H20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 7h8M8 11h5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></span>
        <span class="func-label"><strong>知识库</strong><small>Knowledge</small></span>
      </div>
      <div
        class="func-item"
        :class="{ active: $route.name === 'apps' && !activeRecentId }"
        v-show="!groupsCollapsed.collab"
        @click="navigate('apps')"
      >
        <span class="func-icon"><svg viewBox="0 0 24 24" fill="none"><path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <span class="func-label"><strong>应用中心</strong><small>Apps</small></span>
      </div>

      <!-- Agent -->
      <div class="func-group-label" :class="{ 'is-collapsed': groupsCollapsed.agent }" @click="toggleGroup('agent')">
        <span>Agent</span>
        <span class="group-toggle-icon"><svg viewBox="0 0 24 24" fill="none" width="12" height="12"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
      </div>
      <div
        class="func-item"
        :class="{ active: $route.name === 'workspace' && !activeRecentId }"
        v-show="!groupsCollapsed.agent"
        @click="navigate('workspace')"
      >
        <span class="func-icon"><svg viewBox="0 0 24 24" fill="none"><path d="M3 12h4l3-9 4 18 3-9h4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
        <span class="func-label"><strong>概览</strong><small>Overview</small></span>
      </div>
      <div
        class="func-item"
        :class="{ active: $route.name === 'outputs' && !activeRecentId }"
        v-show="!groupsCollapsed.agent"
        @click="navigate('outputs')"
      >
        <span class="func-icon"><svg viewBox="0 0 24 24" fill="none"><path d="M5 6h14M5 12h14M5 18h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path><circle cx="8" cy="6" r="1.5" fill="currentColor"></circle><circle cx="12" cy="12" r="1.5" fill="currentColor"></circle><circle cx="16" cy="18" r="1.5" fill="currentColor"></circle></svg></span>
        <span class="func-label"><strong>交付物</strong><small>Outputs</small></span>
      </div>
      <div
        class="func-item"
        :class="{ active: $route.name === 'schedules' && !activeRecentId }"
        v-show="!groupsCollapsed.agent"
        @click="navigate('schedules')"
      >
        <span class="func-icon"><svg viewBox="0 0 24 24" fill="none"><path d="M6 5h12M8 3v4M16 3v4M5 10h14M7 14h4M7 18h8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
        <span class="func-label"><strong>定时任务</strong><small>Schedules</small></span>
      </div>
      <div
        class="func-item"
        :class="{ active: $route.name === 'experts' && !activeRecentId }"
        v-show="!groupsCollapsed.agent"
        @click="navigate('experts')"
      >
        <span class="func-icon"><svg viewBox="0 0 24 24" fill="none"><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path><circle cx="8.5" cy="7" r="4" stroke="currentColor" stroke-width="1.8"></circle><path d="M20 8v6M23 11h-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path></svg></span>
        <span class="func-label"><strong>发现AGENT</strong><small>Discover</small></span>
      </div>
      <div
        class="func-item"
        :class="{ active: $route.name === 'skills' && !activeRecentId }"
        v-show="!groupsCollapsed.agent"
        @click="navigate('skills')"
      >
        <span class="func-icon"><svg viewBox="0 0 24 24" fill="none"><path d="M12 3l2.4 4.86 5.36.78-3.88 3.78.92 5.34L12 15.77 7.2 17.76l.92-5.34L4.24 8.64l5.36-.78L12 3z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"></path></svg></span>
        <span class="func-label"><strong>技能市场</strong><small>Skills</small></span>
      </div>

      <!-- 管理 -->
      <div class="func-group-label" :class="{ 'is-collapsed': groupsCollapsed.admin }" @click="toggleGroup('admin')">
        <span>管理</span>
        <span class="group-toggle-icon"><svg viewBox="0 0 24 24" fill="none" width="12" height="12"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
      </div>
      <div
        class="func-item"
        :class="{ active: $route.name === 'team' && !activeRecentId }"
        v-show="!groupsCollapsed.admin"
        @click="navigate('team')"
      >
        <span class="func-icon"><svg viewBox="0 0 24 24" fill="none"><path d="M16 20v-1a4 4 0 00-4-4H6a4 4 0 00-4 4v1M9 11a4 4 0 100-8 4 4 0 000 8zm13 9v-1a4 4 0 00-3-3.87" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
        <span class="func-label"><strong>企业</strong><small>Organization</small></span>
        <span class="func-item-badge" v-if="teamPendingCount > 0">{{ teamPendingCount > 99 ? '99+' : teamPendingCount }}</span>
      </div>
      <div
        class="func-item"
        :class="{ active: $route.name === 'settings' && !activeRecentId }"
        v-show="!groupsCollapsed.admin"
        @click="navigate('settings')"
      >
        <span class="func-icon"><svg viewBox="0 0 24 24" fill="none"><path d="M12 15.5A3.5 3.5 0 1012 8.5a3.5 3.5 0 000 7zm7.94-2.5a7.96 7.96 0 000-2l2.06-1.6-2-3.46-2.5 1a7.96 7.96 0 00-1.73-1l-.38-2.65h-4l-.38 2.65a7.96 7.96 0 00-1.73 1l-2.5-1-2 3.46L4.06 11a7.96 7.96 0 000 2L2 14.6l2 3.46 2.5-1c.54.42 1.12.75 1.73 1l.38 2.65h4l.38-2.65c.61-.25 1.19-.58 1.73-1l2.5 1 2-3.46L19.94 13z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
        <span class="func-label"><strong>设置</strong><small>Settings</small></span>
      </div>
    </div>

    <!-- 最近打开的文件 -->
    <div v-if="recentFiles.length" class="func-recent">
      <div class="func-recent-head">
        <span class="func-recent-label">最近</span>
        <button class="func-recent-clear" type="button" @click="clearRecentFiles" title="全部关闭">×</button>
      </div>
      <div class="func-recent-list" @scroll="onRecentScroll">
        <div v-for="f in recentFiles" :key="f.id" class="func-recent-item" :class="{ active: activeRecentId === f.id }" @click="openRecentFile(f)" :title="f.name">
          <span class="func-recent-icon">{{ f.icon }}</span>
          <span class="func-recent-name">{{ f.name }}</span>
          <button class="func-recent-close" type="button" @click.stop="removeRecentFile(f.id)" title="关闭">×</button>
        </div>
      </div>
    </div>

    <div class="func-bottom-actions" id="funcBottomActions">
      <div class="sidebar-version-card" :class="{ 'has-upgrade': hasUpgrade }" id="sidebarVersionCard" @click="showVersionPopup = !showVersionPopup">
        <span class="sidebar-version-label">{{ appVersion }}</span>
        <span v-if="hasUpgrade" class="version-upgrade-dot"></span>
      </div>
      <div
        class="func-item logout-nav-item"
        :class="{ 'is-guest': !auth.loggedIn }"
        id="logoutNavItem"
        :aria-label="auth.loggedIn ? '点击进入设置,右侧图标退出登录' : '点击登录'"
      >
        <!-- 主区:头像 + 主副标题 — 已登录跳设置,未登录跳登录 -->
        <span
          class="logout-nav-main"
          role="button"
          :title="auth.loggedIn ? '进入设置' : '登录'"
          @click="onLogoutMainClick"
        >
          <span
            class="func-icon"
            :class="{ 'is-user-avatar': auth.loggedIn }"
            :style="auth.loggedIn && auth.avatarUrl ? { backgroundImage: 'url(' + auth.avatarUrl + ')' } : null"
            aria-hidden="true"
          >
            <template v-if="auth.loggedIn">
              <span v-if="!auth.avatarUrl">{{ logoutAvatarText }}</span>
            </template>
            <svg v-else viewBox="0 0 24 24" fill="none"><path d="M14 4h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M10 8 6 12l4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M7 12h10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
          </span>
          <span class="func-label logout-meta">
            <strong>{{ logoutTitle }}</strong>
            <small>{{ logoutSub }}</small>
          </span>
        </span>
        <!-- 右侧 action:已登录=退出,未登录=登录 -->
        <span
          class="logout-action-icon"
          role="button"
          :title="auth.loggedIn ? '退出登录' : '登录'"
          :aria-label="auth.loggedIn ? '退出登录' : '登录'"
          @click.stop="onLogoutActionClick"
        >
          <svg v-if="auth.loggedIn" viewBox="0 0 24 24" fill="none"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M16 17l5-5-5-5M21 12H9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <svg v-else viewBox="0 0 24 24" fill="none"><path d="M10 17l5-5-5-5M15 12H3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M19 4v16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
        </span>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { clearAuthState } from '../utils/auth'
import { api, FRONTEND_VERSION } from '../utils/api'

export default {
  name: 'FuncBar',
  data() {
    // FRONTEND_VERSION 存的是 UTC 时间戳(YYYYMMDDHHMMSS)，展示统一转 UTC+8
    const _fmtVer = (v) => {
      const m = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/.exec(String(v))
      if (!m) return { ver: 'v' + v, at: String(v) }
      const d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]) + 8 * 3600 * 1000)
      const p = (n) => String(n).padStart(2, '0')
      const Y = d.getUTCFullYear(), M = p(d.getUTCMonth() + 1), D = p(d.getUTCDate())
      const H = p(d.getUTCHours()), Min = p(d.getUTCMinutes())
      return { ver: `v${Y}.${M}.${D}-${H}${Min}`, at: `${Y}-${M}-${D} ${H}:${Min} (UTC+8)` }
    }
    const _v = _fmtVer(FRONTEND_VERSION)
    return {
      appVersion: _v.ver,
      appUpdatedAt: _v.at,
      _unreadTimer: null,
      showVersionPopup: false,
      hasUpgrade: false,
      recentFiles: [],
      activeRecentId: '',
      recentPage: 1,
      recentTotal: 0,
      recentLoading: false,
      // 侧边栏分组折叠状态（点击分组标题伸缩本组下面的 items）
      groupsCollapsed: { work: false, collab: false, agent: false, admin: false }
    }
  },
  computed: {
    ...mapState(['funcbarCollapsed', 'auth', 'sessionItems', 'totalUnread', 'teamPendingCount']),
    // 底部用户卡:头像首字
    logoutAvatarText() {
      const n = this.auth && (this.auth.name || this.auth.phone || '')
      return n ? String(n).trim().slice(0, 1) : '我'
    },
    // 底部用户卡:主标题(姓名 / 手机号 / 未登录)
    logoutTitle() {
      if (!this.auth || !this.auth.loggedIn) return '未登录'
      return this.auth.name || this.auth.phone || '已登录'
    },
    // 底部用户卡:副标题(状态文案)
    logoutSub() {
      if (!this.auth || !this.auth.loggedIn) return '点击登录'
      // setupStep<4 表示注册还没完成第二步(完善信息/审核中);正常 4
      const step = this.auth.setupStep || 0
      if (step > 0 && step < 4) return '待完善信息'
      return '在线'
    }
  },
  mounted() {
    this.loadRecentFiles()
    this._onRefresh = (e) => {
      const d = e && e.detail
      if (d && d.renamedDocId && d.newName) {
        var item = this.recentFiles.find(f => f.resourceId === d.renamedDocId)
        if (!item && d.oldName) item = this.recentFiles.find(f => f.name === d.oldName)
        if (item) item.name = d.newName
        return
      }
      this.loadRecentFiles(d)
    }
    window.addEventListener('refresh-recent-files', this._onRefresh)
    this.fetchUnreadCount()
    this._unreadTimer = setInterval(() => { this.fetchUnreadCount() }, 30000)
    // 入职审核小红点全局轮询(任何页都实时显示);只 admin 调,non-admin 静默 403 → 不抛错
    this._syncTeamPending()
    this._pendingTimer = setInterval(() => this._syncTeamPending(), 30000)
    // 创建版本弹窗挂到 body，避免被 funcbar overflow:hidden 裁剪
    this._createVersionPopup()
    // 监听版本升级事件
    this._onFrontendUpgrade = (e) => {
      const info = e.detail
      if (info) {
        this._updatePopupContent(info)
        this.hasUpgrade = true
      }
      this.showVersionPopup = true
    }
    window.addEventListener('frontend-upgrade', this._onFrontendUpgrade)
  },
  watch: {
    '$route'(to, from) {
      if (to.name === 'table-viewer' || to.name === 'markdown-editor') {
        this._syncActiveFromRoute()
      } else {
        this._syncActiveFromRoute()
      }
    },
    showVersionPopup(val) {
      if (this._versionPopupEl) {
        this._versionPopupEl.classList.toggle('open', val)
        if (val) {
          const card = document.getElementById('sidebarVersionCard')
          if (card) {
            const rect = card.getBoundingClientRect()
            this._versionPopupEl.style.left = rect.left + 'px'
            this._versionPopupEl.style.bottom = (window.innerHeight - rect.top + 8) + 'px'
          }
        }
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this._routeRefreshTimer)
    if (this._unreadTimer) clearInterval(this._unreadTimer)
    if (this._pendingTimer) clearInterval(this._pendingTimer)
    if (this._versionPopupEl) document.body.removeChild(this._versionPopupEl)
    if (this._onFrontendUpgrade) window.removeEventListener('frontend-upgrade', this._onFrontendUpgrade)
    if (this._onRefresh) window.removeEventListener('refresh-recent-files', this._onRefresh)
  },
  methods: {
    ...mapMutations(['SET_FUNCBAR_COLLAPSED', 'LOGOUT', 'SET_TEAM_PENDING_COUNT']),
    ...mapActions(['fetchUnreadCount']),
    async _syncTeamPending() {
      // 未登录:直接清零(防止上个账号红点残留)
      if (!this.auth || !this.auth.loggedIn) { this.SET_TEAM_PENDING_COUNT(0); return }
      try {
        const s = await api.getApprovalStats()
        // 拿到数就用真值;返回结构异常也按 0(非 admin 后端可能返空/非数字)
        this.SET_TEAM_PENDING_COUNT(s && typeof s.pending === 'number' ? s.pending : 0)
      } catch (_) {
        // non-admin 403 / 网络抖动 → 置 0,不保留上一账号的值
        this.SET_TEAM_PENDING_COUNT(0)
      }
    },
    _createVersionPopup() {
      this._versionPopupEl = document.createElement('div')
      this._versionPopupEl.className = 'version-popup'
      this._versionPopupEl.innerHTML = `
        <div class="version-popup-header">
          <div class="version-popup-title">版本更新</div>
          <button class="version-popup-close" type="button">&times;</button>
        </div>
        <div class="version-popup-version">${this.appVersion}</div>
        <div class="version-popup-date">更新时间：${this.appUpdatedAt}</div>
        <div class="version-popup-changelog">
          <div class="version-popup-empty">当前已是最新版本</div>
        </div>
        <button class="version-popup-btn" type="button" style="display:none">立即更新</button>
      `
      document.body.appendChild(this._versionPopupEl)
      this._versionPopupEl.querySelector('.version-popup-close').addEventListener('click', () => { this.showVersionPopup = false })
      this._versionPopupEl.querySelector('.version-popup-btn').addEventListener('click', () => { this.doUpdate() })
    },
    _updatePopupContent(info) {
      if (!this._versionPopupEl || !info) return
      const newVersion = (info.version || '').replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})?/, 'v$1.$2.$3-$4$5')
      const publishedAt = info.publishedAt ? new Date(info.publishedAt).toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }) : ''
      const changelog = info.changelog || ''
      // 更新版本号
      const versionEl = this._versionPopupEl.querySelector('.version-popup-version')
      if (versionEl) versionEl.textContent = newVersion
      // 更新时间
      const dateEl = this._versionPopupEl.querySelector('.version-popup-date')
      if (dateEl) dateEl.textContent = publishedAt ? ('发布时间：' + publishedAt) : ''
      // 更新日志
      const logEl = this._versionPopupEl.querySelector('.version-popup-changelog')
      if (logEl) {
        if (changelog) {
          const items = changelog.split('\n').filter(line => line.trim())
          logEl.innerHTML = items.map(line => `<div class="version-popup-log-item"><span class="version-popup-log-dot"></span><span class="version-popup-log-text">${line.replace(/^\d+\.\s*/, '').replace(/</g, '&lt;')}</span></div>`).join('')
        } else {
          logEl.innerHTML = '<div class="version-popup-empty">暂无更新日志</div>'
        }
      }
      // 显示更新按钮
      const btn = this._versionPopupEl.querySelector('.version-popup-btn')
      if (btn) btn.style.display = ''
      // 标题改为提示有新版本
      const titleEl = this._versionPopupEl.querySelector('.version-popup-title')
      if (titleEl) titleEl.textContent = '发现新版本'
    },
    doUpdate() {
      this.showVersionPopup = false
      window.location.reload()
    },
    toggleFuncBar() {
      this.SET_FUNCBAR_COLLAPSED(!this.funcbarCollapsed)
    },
    toggleGroup(key) {
      this.$set(this.groupsCollapsed, key, !this.groupsCollapsed[key])
    },
    navigate(name) {
      this.activeRecentId = ''
      if (name === 'collab') {
        window.dispatchEvent(new CustomEvent('collab-reset-inline'))
      }
      if (this.$route.name !== name) {
        this.$router.push({ name })
      }
    },
    // 点主区(头像/姓名/状态):已登录 → 跳设置;未登录 → 跳登录
    onLogoutMainClick() {
      if (!this.auth.loggedIn) {
        this.$router.push('/auth').catch(() => {})
        return
      }
      if (this.$route.name !== 'settings') {
        this.$router.push({ name: 'settings' }).catch(() => {})
      }
    },
    // 点右侧动作图标:已登录 → 退出;未登录 → 跳登录
    onLogoutActionClick() {
      if (!this.auth.loggedIn) {
        this.$router.push('/auth').catch(() => {})
        return
      }
      this.logout()
    },
    async logout() {
      // 0. 隐藏 iframe 登出 Teable（SameSite=None 已上线，iframe 能带 cookie）
      const host = location.hostname
      const teableHost = host.includes('arp') ? host.replace(/arp/, 'teable') : 'dev-teable.fengbao.com'
      const signoutUrl = `https://${teableHost}/api/auth/signout`
      try {
        const f = document.createElement('iframe')
        f.style.display = 'none'
        f.src = signoutUrl
        document.body.appendChild(f)
        setTimeout(() => { try { f.remove() } catch (e) { /* ignore */ } }, 3000)
      } catch (e) { /* ignore */ }
      // 0.5 通知开发页 Studio iframe 清自身会话（Studio 与 ARP 是两套独立会话/cookie，
      // 只能走 postMessage 契约；DevView 监听该事件转发 auth.logout 给 iframe）。
      // 放在 await api.logout() 之前：趁网络往返 + 路由切走销毁 DevView 之前给 Studio 处理窗口。
      window.dispatchEvent(new CustomEvent('arp-auth-logout'))
      // 1. 请求后端登出，让 token 失效
      try { await api.logout() } catch (e) { /* 失败也继续登出，不阻断 */ }
      // 2. 清本地数据
      clearAuthState()
      this.recentFiles = []
      this.$store.commit('LOGOUT_RESET')
      // 3. 跳转登录页
      this.$router.push({ name: 'auth' }).catch(() => {})
    },
    // ── 最近打开文件（后端 API） ──
    _mapRecentItem(item) {
      const isMd = item.resourceType === 'markdown'
      return {
        id: item.id,
        name: item.name || (isMd ? '文档' : '表格'),
        type: item.resourceType || 'table',
        resourceId: item.resourceId || '',
        url: item.url,
        icon: isMd ? '📝' : '📊'
      }
    },
    async loadRecentFiles(detail) {
      this.recentPage = 1
      try {
        const data = await api.getTableRecents({ page: 1, page_size: 20 })
        if (data && Array.isArray(data.items)) {
          this.recentFiles = data.items.map(this._mapRecentItem)
          this.recentTotal = data.total || 0
        }
      } catch (e) { console.error('[FuncBar] loadRecentFiles error', e); this.recentFiles = []; this.recentTotal = 0 }
      const activeUrl = detail && detail.activeUrl
      const activeDocId = detail && detail.activeDocId
      if (activeUrl) {
        const cur = this.recentFiles.find(f => f.url === activeUrl)
        if (cur) { this.activeRecentId = cur.id; return }
      }
      if (activeDocId) {
        const cur = this.recentFiles.find(f => f.resourceId === activeDocId)
        if (cur) { this.activeRecentId = cur.id; return }
      }
      this._syncActiveFromRoute()
    },
    async loadMoreRecent() {
      if (this.recentLoading || this.recentFiles.length >= this.recentTotal) return
      this.recentLoading = true
      try {
        const nextPage = this.recentPage + 1
        const data = await api.getTableRecents({ page: nextPage, page_size: 20 })
        if (data && Array.isArray(data.items) && data.items.length) {
          const existing = new Set(this.recentFiles.map(f => f.id))
          data.items.forEach(item => {
            if (!existing.has(item.id)) this.recentFiles.push(this._mapRecentItem(item))
          })
          this.recentPage = nextPage
          this.recentTotal = data.total || this.recentTotal
        }
      } catch (e) { /* ignore */ }
      this.recentLoading = false
    },
    onRecentScroll(e) {
      const el = e.target
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 30) {
        this.loadMoreRecent()
      }
    },
    _syncActiveFromRoute() {
      const rn = this.$route.name
      if (rn === 'table-viewer' && this.$route.query.url) {
        const cur = this.recentFiles.find(f => f.url === this.$route.query.url)
        this.activeRecentId = cur ? cur.id : ''
      } else if (rn === 'markdown-editor' && this.$route.params.id) {
        const cur = this.recentFiles.find(f => f.type === 'markdown' && f.resourceId === this.$route.params.id)
        this.activeRecentId = cur ? cur.id : ''
      } else if (rn !== 'table-viewer' && rn !== 'markdown-editor') {
        this.activeRecentId = ''
      }
    },
    async removeRecentFile(id) {
      const wasCurrent = this.activeRecentId === id
      const idx = this.recentFiles.findIndex(f => f.id === id)
      this.recentFiles = this.recentFiles.filter(f => f.id !== id)
      try { await api.removeTableRecent(id) } catch {}
      this.loadRecentFiles()
      if (wasCurrent) {
        const above = idx > 0 ? this.recentFiles[idx - 1] : null
        const below = this.recentFiles[idx] || null
        const next = above || below
        if (next) {
          this.openRecentFile(next)
        } else {
          this.activeRecentId = ''
          this.$router.push({ name: 'collab' }).catch(() => {})
        }
      }
    },
    async clearRecentFiles() {
      const wasActive = !!this.activeRecentId
      this.recentFiles = []
      this.activeRecentId = ''
      try { await api.clearTableRecents() } catch {}
      this.loadRecentFiles()
      if (wasActive) this.$router.push({ name: 'collab' }).catch(() => {})
    },
    openRecentFile(f) {
      this.activeRecentId = f.id
      if (f.type === 'markdown' && f.resourceId) {
        window.__skipDocRecord = true
        this.$router.push({ name: 'markdown-editor', params: { id: f.resourceId } }).catch(() => {})
      } else {
        window.__skipDocRecord = true
        var routeId = f.resourceId || ('__direct_' + f.url.replace(/\W/g, '').slice(-16) + '__')
        var query = { url: f.url }
        if (f.name) query.docName = f.name
        this.$router.push({ name: 'table-viewer', params: { id: routeId }, query: query }).catch(() => {})
      }
    }
  }
}
</script>
